import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { SchoolbagFile } from '../models/schoolbag-file';
import { SchoolBagFileFactory } from '../models/factories/school-bag-file-factory';
import { ApplicationStateService } from './application-state.service';

@Injectable({
    providedIn: 'root'
})
export class SchoolBagFileService {

    schoolBagFiles: Array<SchoolbagFile>;

    constructor(private applicationStateService: ApplicationStateService, private crudService: CrudService) {
    }

    getSchoolBagFiles(): Promise<Array<SchoolbagFile>> {

        if (!this.applicationStateService.userData.loggedIn) {
            return new Promise<Array<SchoolbagFile>>(resolve => {
                this.schoolBagFiles = [];
                resolve([]);

                return;
            });
        }

        return new Promise(resolve => {

            if (this.schoolBagFiles) {
                resolve(this.schoolBagFiles);

                return;
            }

            this.crudService.getAllEntities(SchoolbagFile, new SchoolBagFileFactory(), {})
                .then(result => {
                    this.schoolBagFiles = result as Array<SchoolbagFile>;
                    resolve(result as Array<SchoolbagFile>);
                });
        });
    }
}
